module.exports = __webpack_public_path__ + "static/media/deri-busd.e53f25a3.svg";